const breadcrumb = {
  EN: {
    home: 'Brand',
    project: {
      brand: 'Brand',
      project: 'Project',
      usermanagement: 'End User',
    },
    brand: {
      brand: 'Brand',
      project: 'Project',
      brandmanagement: 'Brand Settings',
      rolemanagement: 'Role',
      adminmanagement: 'Admin',
      usermanagement: 'User',
      projectmanagement: 'Project',
    },
  },
};

export default breadcrumb;
